export const zhTranslation = {
  header: {
    homeProjectors: "家用投影仪",
    portableProjectors: "便携式投影仪",
    support: "支持",
    promotion: "促销",
    dropdownHome: "家用投影仪型号及配件",
    dropdownPortable: "便携式投影仪型号及移动电源",
    dropdownSupport: "常见问题、手册和联系信息",
  },
  main: {
    fastSelfHelpSupport: "快速自助支持",
    card1: {
      title: "售前问题",
      description: "如何以大折扣购买？",
      link: "了解更多",
    },
    card2: {
      title: "产品支持",
      description: "使用投影仪时遇到问题？",
      link: "选择您的型号",
    },
    card3: {
      title: "售后服务",
      description: "保修、退货、换货政策",
      link: "了解更多",
    },
    getSupport: {
      title: "从我们这里获得支持",
      replyTime: "我们通常在 1 个工作日内回复。",
      checkFaq: "对于设备问题，请先查看{faqLink}",
    },
  },
  form: {
    name: "姓名",
    email: "电子邮件",
    order_id: "您的订单号",
    orderNumberHelp: "如何找到我的订单号？",
    describeIssue: "请描述问题",
    descriptionHelp: "请尽可能提供故障的照片和视频，以便我们快速确定解决方案。",
    fileUpload: "文件上传",
    fileUploadInstructions: "{action}到此区域上传。",
    fileUploadInstructionsAction: "点击或拖拽文件",
    fileUploadLimit: "您最多可以上传 5 个文件。",
    filesSelected: "已选择 {{count}}/5 个文件。",
    maxFilesError: "您最多只能上传 5 个文件。",
    surveyTitle: "小调查 - 您希望下一代投影仪有哪些升级？",
    surveyPlaceholder: "例如：我希望它更亮，我希望它声音更大，等等。",
    submit: "提交",
    nextButton: "下一步",
    previousButton: "上一步",
    submitSuccess: "支持工单已提交！我们将尽快与您联系。",
    step2: {
      expectation: {
        label: "它是否满足您的期望？",
        optionYes: "是的，效果很好",
        optionNo: "不，它有问题",
      },
      rating: {
        label: "您如何评价它？",
      },
      features: {
        label: "小调查 - 我们产品的哪些特性最吸引您？",
        placeholder: "例如：外观、实惠的价格、独特的设计等",
      },
    },
    step3: {
      title: "请领取您的激活礼物！它是免费的！",
      gift1Title: "1 年额外保修",
      gift2Title: "180 天免费更换",
      confirmation: "我们将发送一封确认邮件到您的邮箱，请在邮件中确认收到。",
      activateButton: "立即激活",
    },
    step4: {
      title: "您已成功激活保修！",
      line1: "希望您喜欢我们为您准备的激活礼物。",
      line2: "您已收到一封确认邮件。请检查您的收件箱以确认您选择的权益。",
      line3: "如果找不到，请检查您的垃圾邮件文件夹。",
    },
    errors: {
      nameRequired: "姓名是必填项。",
      emailRequired: "电子邮件是必填项。",
      emailInvalid: "电子邮件格式无效。",
      order_idRequired: "订单号是必填项。",
      order_idInvalid: "订单号格式无效 (例如，XXX-XXXXXXX-XXXXXXX)。",
      commentRequired: "请描述问题。",
      filesRequired: "至少需要上传一个文件。",
      surveyRequired: "调查字段为必填项。",
      expectationRequired: "请选择一个选项。",
      ratingRequired: "请提供评分。",
      featuresRequired: "此调查字段为必填项。",
      giftRequired: "请选择一个礼物来激活。",
    },
  },
  footer: {
    newsletterTitle: "订阅我们的新闻通讯",
    newsletterDescription:
      "注册我们的新闻通讯，以接收定制的产品新闻、更新和特别邀请",
    emailPlaceholder: "电子邮件地址",
    signUp: "注册",
    products: "产品",
    support: "支持",
    contactUs: "联系我们",
    preSales: "售前问题",
    productSupport: "产品支持",
    afterSales: "售后服务",
    contactInfo: "联系信息",
    workingHours: "(CST): 周一至周日 上午 9 点 - 下午 7 点",
  },
  contactUs: {
    title: "联系我们",
    description: "如果您的投影仪有一些您无法解决的问题，请及时联系我们并填写表格。我们将在 24 小时内回复您，帮助您解决问题。您也可以在太平洋时间下午 6:30-上午 6:30 期间在线联系我们。",
    email: "邮箱",
    emailAddress: "vip_service@elephas.com.hk",
    phone: "电话 (美国)",
    phoneNumber: "+1 (561) 309-3306",
    workingHours: "周一至周五 上午 9:00-下午 5:00 (太平洋时间)",
    form: {
      name: "姓名",
      email: "邮箱",
      country: "国家",
      productModel: "产品型号",
      amazonOrderNumber: "亚马逊订单号",
      problemsEncountered: "遇到的问题",
      problemsPlaceholder: "请描述您遇到的问题...",
      submit: "提交",
      submitting: "提交中...",
      submitSuccess: "谢谢！您的消息已成功发送。我们将在 24 小时内回复您。",
      errors: {
        nameRequired: "姓名为必填项。",
        emailRequired: "邮箱为必填项。",
        emailInvalid: "请输入有效的邮箱地址。",
        countryRequired: "国家为必填项。",
        amazonOrderNumberRequired: "亚马逊订单号为必填项。",
      },
    },
  },
};
